import { CloudCode } from './cloudcode';

export class RegisterConciergeTasks {

  static registerConcierge_Business(
    fullName: string,
    email: string,
    phone: string,
    successCallback: () => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('generateConciergeAccount_Business', 
      {
        fullName: fullName,
        email: email,
        phone: phone,
      },
      () => {
        successCallback();
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }
}